module.exports = __webpack_public_path__ + "img/aq_2.7872db1b.png";